var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.99902C0 15.522 4.477 19.999 10 19.999C15.523 19.999 20 15.522 20 9.99902C20 4.47602 15.523 -0.000976562 10 -0.000976562C4.477 -0.000976562 0 4.47602 0 9.99902ZM9 6.99902V4.99902H11V6.99902H9ZM9 14.999V8.99902H11V14.999H9Z",
    fill: "#BBB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationFilledIcon);
export default __webpack_public_path__ + "static/media/exclamation-filled-icon.5023def79788d2f3b64b99725ed95f3e.svg";
export { ForwardRef as ReactComponent };